import Switch from '@mui/material/Switch'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Pagination from '@mui/material/Pagination'
import NoDataImg from '../../../assets/img/no-data.gif'
import { IconButton, Menu, MenuItem } from "@mui/material";
import Dropdown from 'react-bootstrap/Dropdown'
import Button from '@mui/material/Button'
import { v4 as uuidv4 } from 'uuid'
import dayjs, { Dayjs } from 'dayjs'
import NavBar from '../../structure/NavBar'
import Form from 'react-bootstrap/Form'
import SearchIcon from '@mui/icons-material/Search'
import InputGroup from 'react-bootstrap/InputGroup'
import AddIcon from '@mui/icons-material/Add'
import { NavBarTop } from '../../structure/NavBarTop'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useCallback, useEffect, useReducer, useState } from 'react'
import Image from '../../custom/Image'
import {
    updateTopHeader,
    updateLoading
} from '../../../redux/features/common/commonSlice'
import { useDispatch, useSelector } from 'react-redux'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast, showToast } from '../../constants/toaster'
import { AddRadio } from './AddRadio'
import Utils from '../../constants/Utils'
import { Box } from '@mui/material'
import InsufficientPermission from '../../custom/InSufficientPermission'
import { RadioPlayer } from './RadioPlayer';
const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const RadioList = props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { formatDate } = Utils();
    const [callAPi, setCallAPi] = useState('')
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const [bannerImage, setBannerImage] = useState(null)
    const [searchText, setSearchText] = useState('')
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [statusDropdownText, setStatusDropdownText] = useState('Select Status')
    const [categoryDropdownDataList, setCategoryDropdownDataList] = useState([])
    const [typeDropdownText, setTypeDropdownText] = useState({
        id: null,
        value: 'Select Category'
    })
    const [value, setValue] = useState(dayjs())
    const dispatch = useDispatch()
    const [datalist, setDatalist] = useState([])
    const [defaultWidgetOption, setDefaultWidgetOption] = useState(null)
    const [widgetKeyValueData, setWidgetKeyValueData] = useState([])
    const [showAddBanner, setShowAddBanner] = useState(false)
    const [showRadioPlayer, setShowRadioPlayer] = useState(false)
    const [radioPlaybackUrl, setRadioPlaybackUrl] = useState('')
    const [sort_type, setSortType] = useState('createdAt')
    const [sort_order, setSortOrder] = useState(false)
    const userData = useSelector(state => state?.userData)
    const [edit, setEdit] = useState(false)
    const [active, setActive] = useState(false)
    const [deletePermission, setDeletePermission] = useState(false)
    const [view, setView] = useState(false)
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 5,
        totalPages: 1
    })
    const [radioFormData, setRadioFormData] = useState({
        id: '',
        title: '',
        description: '',
        thumbnail: '',
        categoryId: '',
        playBackUrl: '',
        accessType: 'FREE',
        mediaType: 'AUDIO',
        amount: 0.0
    })
    const [thumbanailControl, setThumbanailControl] = useState({
        showError: false,
        errorMessage: '',
        showImage: false,
        imageData: null
    })
    const [filterFileControl, setFilterFileControl] = useState({
        showError: false,
        errorMessage: '',
        showImage: false,
        imageData: null
    })
    const [page, setPage] = useState(1)
    const handleChange = (event, value) => {
        setPage(value)
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 5
        })
        setCallAPi(uuidv4())
    }

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        // setBannerFormData({
        //     ...item,
        //     startDate: new Date(item?.startDate),
        //     endDate: new Date(item?.endDate)
        // })
        setThumbanailControl({
            ...thumbanailControl,
            imageData: item?.imageUrl
        })
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOnSubmitRadioModel = async (url) => {
        try {
            if (url) {
                // Prepare the JSON data to be sent in the POST request
                let postJson = {
                    id: radioFormData?.id,
                    title: radioFormData?.title,
                    description: radioFormData?.description,
                    thumbnail: url,
                    categoryId: radioFormData?.categoryId,
                    playBackUrl: radioFormData?.playBackUrl,
                    accessType: radioFormData?.accessType,
                    mediaType: radioFormData?.mediaType,
                    amount: radioFormData?.amount
                };

                dispatch(updateLoading(true));
                let path = urls.addRadio;
                var res = await ApiCaller.post(postJson, path, userData?.access_token);
                const response = await res.response.json();
                if (response.status === '200') {
                    setShowAddBanner(false);
                    dispatch(updateLoading(false));
                    showToast(response?.message);
                    getRadioList();
                    handleHideModel();
                    setCallAPi(uuidv4())
                } else {
                    dispatch(updateLoading(false));
                    showDangerToast(response.message);
                }
            } else {
                showDangerToast('URL not provided.');
            }
        } catch (error) {
            dispatch(updateLoading(false));
            console.error(error);
            showDangerToast(error.message);
        }
    };


    const handleAddFilter = () => {
        getWidgetKeyValuePair()
        setBannerImage(null)
        setShowAddBanner(true)
    }

    const handleFilterClick = useCallback(() => {
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }, [searchText, statusDropdownText, startDate, endDate])

    const handleResetFilter = () => {
        setStartDate(null)
        setEndDate(null)
        setStatusDropdownText('Select Status')
        setTypeDropdownText({
            id: null,
            value: 'Select Category'
        })
        setSearchText('')
        setPage(1)
        setPagerecord({
            ...pagerecord,
            pageNumber: 1
        })
        setCallAPi(uuidv4())
    }

    const getWidgetKeyValuePair = async roleId => {
        try {
            dispatch(updateLoading(true))
            let path = urls.widgetKeyValuePair
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                let tempWidgetKeyValueList = [{ value: '', label: 'Select Widget' }]
                response?.data?.map((data, i) => {
                    tempWidgetKeyValueList.push({ value: data?.value, label: data?.key })
                    if (data?.key === roleId) {
                        setDefaultWidgetOption({ value: data?.value, label: data?.key })
                    }
                })
                setWidgetKeyValueData(tempWidgetKeyValueList)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleEditBanner = item => {
        setShowAddBanner(true)
        handleClose();
        setRadioFormData(item)
    }

    useEffect(() => {
        dispatch(updateTopHeader('Radio Manager'))
    }, [])

    useEffect(() => {
        if (viewPermission) {
            getRadioList()
            getCategoryList()
        }
    }, [callAPi])


    const getCategoryList = async () => {
        try {
            dispatch(updateLoading(true))
            let path = urls.liveReelCategoryKeyValuePair
            let postJson = {
                name: '',
                type: 'ALL'
            }
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                console.log(response?.data)
                let tempArray = [{
                    id: null,
                    value: 'Select Category'
                }]
                for (let i = 0; i < response?.data?.length; i++) {
                    tempArray.push({
                        id: response?.data?.[i]?.id,
                        value: response?.data?.[i]?.name
                    })
                }
                setCategoryDropdownDataList(tempArray)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleStatusChange = async (event, id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.changeRadioStatus + '?id=' + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                showToast(response?.message)
                getRadioList()
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }
    const handleAdminApproveStatusChange = async (event, id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.changeRadioAdminApprovedStatus + '?id=' + id
            let res = await ApiCaller.get({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                showToast(response?.message)
                getRadioList()
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = true;
    let deletePermissionVal = true;
    let activePermission = true;

    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '29') {
                return element
            }
        })?.permissions
        viewPermission = currentModulePermission.find((element) => {
            if (element.name === 'VIEW') {
                return element
            }
        }).isEnable
        editPermission = currentModulePermission.find((element) => {
            if (element.name === 'EDIT') {
                return element
            }
        }).isEnable
        deletePermissionVal = currentModulePermission.find((element) => {
            if (element.name === 'DELETE') {
                return element
            }
        }).isEnable
        activePermission = currentModulePermission.find((element) => {
            if (element.name === 'ACTIVE') {
                return element
            }
        }).isEnable
    }


    const getRadioList = async () => {
        let startDateObject
        let endDateObject
        if (startDate?.toDate()) {
            let newDate = new Date(startDate?.toDate())
            newDate.setDate(newDate.getDate() + 1)
            startDateObject = newDate
        }
        if (endDate?.toDate()) {
            let newDate = new Date(endDate?.toDate())
            newDate.setDate(newDate.getDate() + 1)
            endDateObject = newDate
        }
        try {
            dispatch(updateLoading(true))
            let postJson = {
                name: searchText?.trim(),
                pageNumber: pagerecord?.pageNumber - 1 || 0,
                pageSize: pagerecord.pageSize || 5,
                shortingKey: sort_type,
                active:
                    statusDropdownText === 'Active'
                        ? true
                        : statusDropdownText === 'In Active'
                            ? false
                            : null,
                categoryId: typeDropdownText?.id,
                asc: sort_order,
                startDate: startDateObject !== null ? startDateObject : '',
                endDate: endDateObject !== null ? endDateObject : ''
            }
            let path = urls.radioList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setDatalist(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.totalItems,
                    totalPages: response?.data?.totalPages,
                    pageNumber: pagerecord?.pageNumber,
                    pageSize: 5
                })
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const handleHideModel = () => {
        setShowAddBanner(false)
        setFilterFileControl({
            showError: true,
            errorMessage: '',
            showImage: false,
            imageData: null
        })
    }

    return (
        <>
            <>
                <NavBar />
                <div className='main-content'>
                    <NavBarTop />
                    <div className='header'>
                        <div className='logo'>
                            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                        </div>
                    </div>
                    {
                        viewPermission ? (
                            <>
                                <div className='container-fluid mt--7'>
                                    <div className='row'>
                                        <div className='col text-left'>
                                            <div className='card shadow'>
                                                <div className='card-header border-0'>
                                                    <div className='row align-items-center text-left'>
                                                        <div className='col'>
                                                            <h3 className='mb-0'>Radio List</h3>
                                                        </div>
                                                        <div className='col text-right'>
                                                            {userData.admin ? (
                                                                <a
                                                                    onClick={handleAddFilter}
                                                                    className='btn btn-sm btn-primary text-white'
                                                                >
                                                                    <AddIcon />
                                                                    Add New
                                                                </a>
                                                            ) : editPermission ? (
                                                                <a
                                                                    onClick={handleAddFilter}
                                                                    className='btn btn-sm btn-primary text-white'
                                                                >
                                                                    <AddIcon />
                                                                    Add New
                                                                </a>
                                                            ) : (
                                                                <></>
                                                            )}

                                                            {/* <a href='#!' className='btn btn-sm btn-primary'>
                        See all
                      </a> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='card-header border-0'>
                                                    <div className='row align-items-center text-left'>
                                                        <div className='col-md-3'>
                                                            <InputGroup
                                                                className='mb-2'
                                                                style={{ borderRadius: '10px' }}
                                                            >
                                                                <Form.Control
                                                                    placeholder='Search by Title'
                                                                    value={searchText}
                                                                    onChange={e => setSearchText(e.target.value)}
                                                                    aria-label='Amount (to the nearest dollar)'
                                                                />
                                                            </InputGroup>
                                                        </div>
                                                        <div className='col-md-1 mb-2 mr-4 '>
                                                            <Dropdown>
                                                                <Dropdown.Toggle
                                                                    variant='success'
                                                                    style={{
                                                                        backgroundColor: 'white',
                                                                        color: 'black',
                                                                        border: '1px solid #cad1d7',
                                                                        boxShadow: 'none',
                                                                        transform: 'none'
                                                                    }}
                                                                    id='dropdown-basic'
                                                                >
                                                                    {statusDropdownText}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item
                                                                        onClick={() =>
                                                                            setStatusDropdownText('Select Status')
                                                                        }
                                                                    >
                                                                        Select Status
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => setStatusDropdownText('Active')}
                                                                    >
                                                                        Active
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => setStatusDropdownText('In Active')}
                                                                    >
                                                                        In Active
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div className='col-md-1 mb-2 mr-4 ml-2'>
                                                            <Dropdown>
                                                                <Dropdown.Toggle
                                                                    variant='success'
                                                                    style={{
                                                                        backgroundColor: 'white',
                                                                        color: 'black',
                                                                        border: '1px solid #cad1d7',
                                                                        boxShadow: 'none',
                                                                        transform: 'none'
                                                                    }}
                                                                    id='dropdown-basic'
                                                                >
                                                                    {typeDropdownText?.value}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {categoryDropdownDataList?.map((data, i) => {
                                                                        return <>
                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    setTypeDropdownText(data)
                                                                                }
                                                                            >
                                                                                {data?.value}
                                                                            </Dropdown.Item>
                                                                        </>
                                                                    })}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div
                                                            className='col-md-6 mb-3'
                                                            style={{ marginLeft: '40px' }}
                                                        >
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DemoContainer
                                                                    components={['DatePicker', 'DatePicker']}
                                                                >
                                                                    <DatePicker
                                                                        className='custom-date'
                                                                        label='From Date'
                                                                        value={startDate}
                                                                        onChange={newValue => setStartDate(newValue)}
                                                                        maxDate={endDate}
                                                                    />
                                                                    <DatePicker
                                                                        label='To Date'
                                                                        value={endDate}
                                                                        onChange={newValue => setEndDate(newValue)}
                                                                        minDate={startDate}
                                                                    />
                                                                </DemoContainer>
                                                            </LocalizationProvider>
                                                        </div>
                                                        <div className='col-md-3 mb-2'>
                                                            <Button
                                                                variant='contained'
                                                                className='custom-filter-btn'
                                                                onClick={handleFilterClick}
                                                            >
                                                                Filter
                                                            </Button>
                                                            <Button
                                                                variant='contained'
                                                                className='ml-2 custom-filter-btn'
                                                                onClick={handleResetFilter}
                                                            >
                                                                Reset
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='table-responsive'>
                                                    {datalist && datalist?.length > 0 ? (
                                                        <>
                                                            <table className='table align-items-center table-flush'>
                                                                <thead className='thead-light'>
                                                                    <tr>
                                                                        <th scope='col'>S/No.</th>
                                                                        <th scope='col'>Title</th>
                                                                        <th scope='col'>Username</th>
                                                                        <th scope='col'>Playback Url</th>
                                                                        <th scope='col'>Thumbnail</th>
                                                                        <th scope='col'>Type</th>
                                                                        <th scope='col'>Created At</th>
                                                                        <th scope='col'>Approved</th>
                                                                        <th scope='col'>Status</th>
                                                                        {editPermission && <th scope='col' >Action</th>}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {datalist &&
                                                                        datalist?.map((data, i) => {
                                                                            return (
                                                                                <>
                                                                                    <tr>
                                                                                        <td>{i + 1}</td>
                                                                                        <td>{data?.title}</td>
                                                                                        <td>{data?.userName}</td>
                                                                                        <td><label style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => {
                                                                                            if (data?.playBackUrl) {
                                                                                                setShowRadioPlayer(!showRadioPlayer)
                                                                                                setRadioPlaybackUrl(data?.playBackUrl)
                                                                                            }
                                                                                        }}>Watch</label></td>
                                                                                        <td>
                                                                                            <Image
                                                                                                image={{
                                                                                                    id: 1,
                                                                                                    src: data?.thumbnail
                                                                                                }}
                                                                                                width='80px'
                                                                                                height='auto
'
                                                                                            />
                                                                                        </td>
                                                                                        <td>{data?.mediaType === 'AUDIO' ? 'Audio' : data?.type === 'VIDEO' ? 'Video' : '-'}</td>
                                                                                        <td>
                                                                                            {formatDate(data?.createdAt)}
                                                                                        </td>
                                                                                        <td>
                                                                                            {userData.admin ? (
                                                                                                <Switch
                                                                                                    {...label}
                                                                                                    checked={data?.adminApproved}
                                                                                                    onChange={e =>
                                                                                                        handleAdminApproveStatusChange(e, data?.id)
                                                                                                    }
                                                                                                    size='small'
                                                                                                />
                                                                                            ) : viewPermission ? (
                                                                                                <Switch
                                                                                                    {...label}
                                                                                                    disabled={!activePermission}
                                                                                                    checked={data?.adminApproved}
                                                                                                    onChange={e =>
                                                                                                        handleAdminApproveStatusChange(e, data?.id)
                                                                                                    }
                                                                                                    size='small'
                                                                                                />
                                                                                            ) : (
                                                                                                <></>
                                                                                            )}
                                                                                        </td>
                                                                                        <td>
                                                                                            {userData.admin ? (
                                                                                                <Switch
                                                                                                    {...label}
                                                                                                    checked={data?.active}
                                                                                                    onChange={e =>
                                                                                                        handleStatusChange(e, data?.id)
                                                                                                    }
                                                                                                    size='small'
                                                                                                />
                                                                                            ) : viewPermission ? (
                                                                                                <Switch
                                                                                                    {...label}
                                                                                                    disabled={!activePermission}
                                                                                                    checked={data?.active}
                                                                                                    onChange={e =>
                                                                                                        handleStatusChange(e, data?.id)
                                                                                                    }
                                                                                                    size='small'
                                                                                                />
                                                                                            ) : (
                                                                                                <></>
                                                                                            )}
                                                                                        </td>
                                                                                        {
                                                                                            editPermission &&
                                                                                            <td className='text-right'>
                                                                                                <IconButton size="small" onClick={(e) => handleClick(e, data)}>
                                                                                                    <MoreVertIcon />
                                                                                                </IconButton>
                                                                                                <Menu
                                                                                                    anchorEl={anchorEl}
                                                                                                    open={open}
                                                                                                    onClose={handleClose}
                                                                                                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                                                                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                                                                >
                                                                                                    {(userData.admin || editPermission) && (
                                                                                                        <MenuItem
                                                                                                            onClick={() => handleEditBanner(data)}
                                                                                                        >
                                                                                                            Edit
                                                                                                        </MenuItem>
                                                                                                    )}
                                                                                                </Menu>
                                                                                            </td>
                                                                                        }
                                                                                    </tr>
                                                                                </>
                                                                            )
                                                                        })}
                                                                </tbody>
                                                            </table>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className='text-center'>
                                                                <img width={'25%'} src={NoDataImg}></img>
                                                                <br />
                                                                <label style={{ fontWeight: 'bold' }}>
                                                                    {LOADING_ENABLE ? (
                                                                        <>Loading Data.....</>
                                                                    ) : (
                                                                        <>No Data Found</>
                                                                    )}
                                                                </label>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                {datalist && datalist.length > 0 ? (
                                                    <>
                                                        <div className='card-footer py-4'>
                                                            <Box
                                                                display='flex'
                                                                justifyContent='right'
                                                                alignItems='center'
                                                            >
                                                                <span>Total record: {pagerecord?.totalItems}</span>
                                                                <Pagination
                                                                    className='custom-pagination-class'
                                                                    count={pagerecord?.totalPages}
                                                                    page={page}
                                                                    onChange={handleChange}
                                                                    color='secondary'
                                                                />
                                                            </Box>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* <Footer /> */}
                                </div>
                                <AddRadio
                                    show={showAddBanner}
                                    radioFormData={radioFormData}
                                    widgetKeyValueData={widgetKeyValueData}
                                    defaultWidgetOption={defaultWidgetOption}
                                    setRadioFormData={setRadioFormData}
                                    setBannerImage={setBannerImage}
                                    bannerImage={bannerImage}
                                    onSubmit={handleOnSubmitRadioModel}
                                    onHide={() => handleHideModel()}
                                    filterFileControl={filterFileControl}
                                    setFilterFileControl={setFilterFileControl}
                                    thumbanailControl={thumbanailControl}
                                    setThumbanailControl={setThumbanailControl}
                                />
                                <RadioPlayer
                                    show={showRadioPlayer}
                                    radioPlaybackUrl={radioPlaybackUrl}
                                    onHide={() => setShowRadioPlayer(!showRadioPlayer)}
                                />
                            </>
                        ) : (<InsufficientPermission />)
                    }
                </div>
            </>
        </>
    )
}
